// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../../../assets/img/shineShadow.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Alfa+Slab+One&family=Bitter:wght@400;700;900&family=Crimson+Pro:wght@700;900&family=Noto+Serif:wght@900&family=Roboto:wght@400;500;700;900&display=swap);"]);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.diamondMain {
  background-color: #07405e;
  display: flex;
  align-items: center;
  flex-direction: column;
  width: 100%;
  height: 100dvh;
  overflow-y: auto;
}
.diamondMain .diamondContainer {
  height: 85%;
  display: flex;
  align-items: center;
  flex-direction: column;
  width: 97%;
  height: 100dvh;
  padding: 10px;
  position: relative;
}
@media (min-width: 450px) {
  .diamondMain .diamondContainer {
    width: 400px;
  }
}
@media only screen and (max-height: 712px) {
  .diamondMain .diamondContainer {
    height: 100%;
  }
}
.diamondMain .diamondContainer .diamondPreview {
  width: 100%;
  height: 50%;
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
@media only screen and (max-height: 745px) {
  .diamondMain .diamondContainer .diamondPreview {
    height: 43%;
  }
}
.diamondMain .diamondContainer .diamond {
  background-repeat: no-repeat;
  background-position: center;
  width: 200px;
  height: 200px;
  z-index: 2;
  position: relative;
  display: flex;
  align-self: center;
  align-content: center;
  justify-content: center;
  background-size: 100% 100%;
  margin-top: 60px;
}
.diamondMain .diamondContainer .diamondShine {
  position: absolute;
  animation: clock-direction 4s infinite linear;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-size: cover;
  display: flex;
  opacity: 0.5;
  margin-top: 60px;
  width: 270px;
  height: 270px;
  z-index: 1;
}
.diamondMain .diamondContainer .diamondShadow {
  position: absolute;
  animation: reverse-rotate 4s infinite linear;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  opacity: 0.5;
  display: flex;
  width: 270px;
  height: 270px;
  margin-top: 60px;
  background-size: cover;
  z-index: 1;
}
.diamondMain .diamondContainer .diamondStats {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.diamondMain .diamondContainer .diamondStats .diamondHeading {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  position: relative;
}
.diamondMain .diamondContainer .diamondStats .diamondHeading .diamondNumber {
  display: flex;
  justify-content: center;
  position: absolute;
  top: -20px;
  min-width: 64px;
  width: 130px;
  height: 42px;
  border-radius: 20px;
  background: linear-gradient(to right, #6D4ECB, #FF6B6B);
  z-index: 3;
}
.diamondMain .diamondContainer .diamondStats .diamondHeading .diamondNumber .locked {
  border-left: 1px solid white;
  color: #FFFFFF;
  padding-left: 3px;
}
.diamondMain .diamondContainer .diamondStats .diamondHeading .diamondNumber .count,
.diamondMain .diamondContainer .diamondStats .diamondHeading .diamondNumber .lockedNum {
  color: #FFFFFF;
  font-family: "Roboto", sans-serif;
  text-align: center;
  font-size: 24px;
  margin: 0px;
  margin-top: 7px;
  font-weight: 400;
  padding-right: 20px;
}
.diamondMain .diamondContainer .diamondStats .diamondHeading .diamondNumber .lockedNum {
  margin-top: 0px;
  padding: 0px;
}
.diamondMain .diamondContainer .diamondStats .diamondHeading .title {
  color: #FFFFFF;
  margin-top: 40px;
  font-family: "Crimson Pro", serif;
  font-size: 40px;
  margin-bottom: 0px;
}
.diamondMain .diamondContainer .diamondStats .diamondHeading .description {
  color: #699BB6;
  text-align: center;
  font-size: 17px;
  margin: 0;
  margin-top: 10px;
}
.diamondMain .diamondContainer .diamondStats footer {
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.diamondMain .diamondContainer .diamondStats footer .tradeBlock {
  position: absolute;
  display: flex;
  justify-content: space-between;
  width: 320px;
  z-index: 5;
  bottom: 130px;
}
.diamondMain .diamondContainer .diamondStats footer .tradeBlock .btnsBlock {
  display: flex;
  width: 163px;
  height: 48px;
  border-radius: 10px;
  border-top: 1px solid #699BB6;
  border-left: 1px solid #699BB6;
  border-bottom: 1px solid #699BB6;
}
.diamondMain .diamondContainer .diamondStats footer .tradeBlock .btnsBlock .sellBtnBlock {
  display: flex;
}
.diamondMain .diamondContainer .diamondStats footer .tradeBlock .btnsBlock .sellBtnBlock .dollarSign {
  margin-left: 18px;
  color: #FFFFFF;
  margin-top: 14px;
}
.diamondMain .diamondContainer .diamondStats footer .tradeBlock .btnsBlock .sellBtnBlock input {
  all: unset;
  height: 100%;
  width: 35%;
  color: white;
  font-family: "Roboto", sans-serif;
}
.diamondMain .diamondContainer .diamondStats footer .tradeBlock .btnsBlock .sellBtnBlock .sell {
  all: unset;
  text-align: center;
  display: inline-block;
  height: 105%;
  background: linear-gradient(to right, #6D4ECB, #FF6B6B);
  width: 48%;
  color: white;
  border: 0px solid gray;
  margin-top: -1px;
  border-top-right-radius: 10px;
  border-bottom-right-radius: 10px;
}
.diamondMain .diamondContainer .diamondStats footer .tradeBlock .buy {
  all: unset;
  text-align: center;
  display: inline-block;
  background: linear-gradient(to right, #6D4ECB, #FF6B6B);
  width: 80px;
  height: 48px;
  color: white;
  border: 0px solid gray;
  margin-top: -1px;
  border-radius: 10px;
}
.diamondMain .diamondContainer .diamondStats footer .activateButton,
.diamondMain .diamondContainer .diamondStats footer .exchangeButton {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 320px;
  background: linear-gradient(to right, #6D4ECB, #FF6B6B);
  font-weight: 400;
  margin-top: 50px;
  margin-right: 40px;
  padding: 15px;
  border-radius: 10px;
  text-align: center;
  color: #FFFFFF;
  font-family: "Roboto", sans-serif;
  font-size: 16px;
  border: 0px solid;
  position: absolute;
  bottom: 70px;
  margin: 0 auto;
}
.diamondMain .diamondContainer .diamondStats footer .exchangeButton {
  bottom: 10px;
  height: 50px;
}
.diamondMain .diamondContainer .diamondStats footer .inactiveExchange {
  filter: brightness(0) saturate(100%) invert(59%) sepia(10%) saturate(1390%) hue-rotate(157deg) brightness(96%) contrast(87%);
}

input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Firefox */
input[type=number] {
  -moz-appearance: textfield;
}

.inactiveBtn {
  background: rgba(0, 0, 0, 0) !important;
  color: #699BB6 !important;
  border: 1px solid #699BB6 !important;
}

.inactiveSell {
  background: rgba(0, 0, 0, 0) !important;
  border: 1px solid #699BB6 !important;
  height: 100% !important;
  color: #699BB6 !important;
}

.inactiveSellInput,
.inactiveDollar {
  color: #699BB6 !important;
}

.diamondImage {
  width: 100px;
  height: 100px;
  z-index: 10;
  position: fixed;
  right: 0;
  left: 0;
  top: 0;
  bottom: 0;
  margin: auto;
  animation: appear 1s linear;
}

.diamondText {
  width: 360px;
  height: 100px;
  z-index: 10;
  position: fixed;
  right: 0;
  left: 0;
  top: 0;
  bottom: 0;
  margin: auto;
  animation: appear 1s linear;
  text-align: center;
  color: #FFFFFF;
  font-family: "Roboto", sans-serif;
  font-size: 20px;
  font-style: normal;
  font-weight: 500;
  line-height: 140%;
  animation: appear 0.15s linear;
}

.diamondClose {
  width: 320px;
  height: 20px;
  padding: 24px;
  background: linear-gradient(to right, #6D4ECB, #FF6B6B);
  text-align: center;
  color: #FFFFFF;
  font-family: "Roboto", sans-serif;
  font-weight: 400;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 10px;
  font-size: 16px;
  font-style: normal;
  border: 0px solid;
  z-index: 10;
  position: fixed;
  right: 0;
  left: 0;
  top: 0;
  bottom: -80dvh;
  margin: auto;
  animation: appear 0.15s linear;
}

.minimize {
  animation: minimize 1s linear;
  -webkit-animation-fill-mode: forwards;
}

.active {
  border: 2px solid rgb(149, 179, 202);
}
.active h1 {
  color: #FFFFFF !important;
}
.active p {
  color: #FFFFFF;
  opacity: 1 !important;
}

@keyframes clock-direction {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
@keyframes reverse-rotate {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(-360deg);
  }
}
@keyframes minimize {
  0% {
    transform: scale(1);
    opacity: 1;
  }
  50% {
    transform: scale(0.5);
    opacity: 0.5;
  }
  100% {
    transform: scale(0);
    opacity: 0;
    width: 0px;
    height: 0px;
    opacity: 0.8;
  }
}
@keyframes pulse {
  0% {
    -webkit-transform: scale(1);
  }
  50% {
    -webkit-transform: scale(1.3);
  }
  100% {
    -webkit-transform: scale(1);
  }
}
@keyframes appear {
  0% {
    opacity: 0;
  }
  50% {
    opacity: 0.5;
  }
  100% {
    opacity: 1;
  }
}`, "",{"version":3,"sources":["webpack://./src/modules/diamonds/diamondsList/diamondScreen/index.scss","webpack://./src/scss/colors.scss","webpack://./src/scss/fonts.scss"],"names":[],"mappings":"AAGA;EACE,yBAAA;EACA,aAAA;EACA,mBAAA;EACA,sBAAA;EACA,WAAA;EACA,cAAA;EACA,gBAAA;AADF;AAEE;EAIE,WAAA;EAIA,aAAA;EACA,mBAAA;EACA,sBAAA;EACA,UAAA;EACA,cAAA;EACA,aAAA;EACA,kBAAA;AANJ;AAPI;EADF;IAEI,YAAA;EAUJ;AACF;AARI;EALF;IAMI,YAAA;EAWJ;AACF;AAHI;EACE,WAAA;EACA,WAAA;EAIA,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;AAEN;AATM;EAHF;IAII,WAAA;EAYN;AACF;AALI;EACE,4BAAA;EACA,2BAAA;EACA,YAAA;EACA,aAAA;EACA,UAAA;EACA,kBAAA;EACA,aAAA;EACA,kBAAA;EACA,qBAAA;EACA,uBAAA;EACA,0BAAA;EACA,gBAAA;AAON;AALI;EACE,kBAAA;EACA,6CAAA;EACA,yDAAA;EACA,sBAAA;EACA,aAAA;EACA,YAAA;EACA,gBAAA;EACA,YAAA;EACA,aAAA;EACA,UAAA;AAON;AALI;EACE,kBAAA;EACA,4CAAA;EACA,yDAAA;EACA,YAAA;EACA,aAAA;EACA,YAAA;EACA,aAAA;EACA,gBAAA;EAEA,sBAAA;EACA,UAAA;AAMN;AAJI;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;AAMN;AALM;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;AAOR;AANQ;EACE,aAAA;EACA,uBAAA;EACA,kBAAA;EACA,UAAA;EACA,eAAA;EACA,YAAA;EACA,YAAA;EACA,mBAAA;EACA,uDAAA;EACA,UAAA;AAQV;AAPU;EACE,4BAAA;EACA,cCrGC;EDsGD,iBAAA;AASZ;AAPU;;EAEE,cC1GC;ED2GD,iCEtGH;EFuGG,kBAAA;EACA,eAAA;EACA,WAAA;EACA,eAAA;EACA,gBAAA;EACA,mBAAA;AASZ;AAPU;EACE,eAAA;EACA,YAAA;AASZ;AANQ;EACE,cCzHG;ED0HH,gBAAA;EACA,iCEzHI;EF0HJ,eAAA;EACA,kBAAA;AAQV;AANQ;EACE,cC/HO;EDgIP,kBAAA;EACA,eAAA;EACA,SAAA;EACA,gBAAA;AAQV;AALM;EACE,WAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,mBAAA;AAOR;AALQ;EACE,kBAAA;EACA,aAAA;EACA,8BAAA;EACA,YAAA;EACA,UAAA;EACA,aAAA;AAOV;AANU;EACE,aAAA;EACA,YAAA;EACA,YAAA;EACA,mBAAA;EACA,6BAAA;EACA,8BAAA;EACA,gCAAA;AAQZ;AAPY;EACE,aAAA;AASd;AARc;EACE,iBAAA;EACA,cCjKH;EDkKG,gBAAA;AAUhB;AARc;EACE,UAAA;EACA,YAAA;EACA,UAAA;EACA,YAAA;EACA,iCEpKP;AF8KT;AARc;EACE,UAAA;EACA,kBAAA;EACA,qBAAA;EACA,YAAA;EACA,uDAAA;EACA,UAAA;EACA,YAAA;EACA,sBAAA;EACA,gBAAA;EACA,6BAAA;EACA,gCAAA;AAUhB;AANU;EACE,UAAA;EACA,kBAAA;EACA,qBAAA;EACA,uDAAA;EACA,WAAA;EACA,YAAA;EACA,YAAA;EACA,sBAAA;EACA,gBAAA;EACA,mBAAA;AAQZ;AALQ;;EAEE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,YAAA;EACA,uDAAA;EACA,gBAAA;EACA,gBAAA;EAEA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,kBAAA;EACA,cCrNG;EDsNH,iCEjND;EFkNC,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,YAAA;EACA,cAAA;AAMV;AAJQ;EACE,YAAA;EACA,YAAA;AAMV;AAJQ;EACE,4HAAA;AAMV;;AAEA;;EAEE,wBAAA;EACA,SAAA;AACF;;AAEA,YAAA;AACA;EACE,0BAAA;AACF;;AACA;EACE,uCAAA;EACA,yBAAA;EACA,oCAAA;AAEF;;AACA;EACE,uCAAA;EACA,oCAAA;EACA,uBAAA;EACA,yBAAA;AAEF;;AAAA;;EAEE,yBAAA;AAGF;;AAAA;EACE,YAAA;EACA,aAAA;EACA,WAAA;EACA,eAAA;EACA,QAAA;EACA,OAAA;EACA,MAAA;EACA,SAAA;EACA,YAAA;EACA,2BAAA;AAGF;;AADA;EACE,YAAA;EACA,aAAA;EACA,WAAA;EACA,eAAA;EACA,QAAA;EACA,OAAA;EACA,MAAA;EACA,SAAA;EACA,YAAA;EACA,2BAAA;EACA,kBAAA;EACA,cC7RW;ED8RX,iCEzRO;EF0RP,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,8BAAA;AAIF;;AAAA;EACE,YAAA;EACA,YAAA;EACA,aAAA;EACA,uDAAA;EACA,kBAAA;EACA,cC7SW;ED8SX,iCEzSO;EF0SP,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,mBAAA;EACA,eAAA;EACA,kBAAA;EACA,iBAAA;EACA,WAAA;EACA,eAAA;EACA,QAAA;EACA,OAAA;EACA,MAAA;EACA,cAAA;EACA,YAAA;EACA,8BAAA;AAGF;;AADA;EACE,6BAAA;EACA,qCAAA;AAIF;;AADA;EACE,oCAAA;AAIF;AAHE;EACE,yBAAA;AAKJ;AAHE;EACE,cC3US;ED4UT,qBAAA;AAKJ;;AAFA;EACE;IACE,uBAAA;EAKF;EAHA;IACE,yBAAA;EAKF;AACF;AAFA;EACE;IACE,uBAAA;EAIF;EAFA;IACE,0BAAA;EAIF;AACF;AADA;EACE;IACE,mBAAA;IACA,UAAA;EAGF;EADA;IACE,qBAAA;IACA,YAAA;EAGF;EADA;IACE,mBAAA;IACA,UAAA;IAEA,UAAA;IACA,WAAA;IACA,YAAA;EAEF;AACF;AACA;EACE;IACE,2BAAA;EACF;EAEA;IACE,6BAAA;EAAF;EAGA;IACE,2BAAA;EADF;AACF;AAKA;EACE;IACE,UAAA;EAHF;EAKA;IACE,YAAA;EAHF;EAKA;IACE,UAAA;EAHF;AACF","sourcesContent":["@import '../../../../scss/colors.scss';\n@import '../../../../scss/fonts.scss';\n\n.diamondMain {\n  background-color: #07405e;\n  display: flex;\n  align-items: center;\n  flex-direction: column;\n  width: 100%;\n  height: 100dvh;\n  overflow-y: auto;\n  .diamondContainer {\n    @media (min-width: 450px) {\n      width: 400px;\n    }\n    height: 85%;\n    @media only screen and (max-height: 712px) {\n      height: 100%;\n    }\n    display: flex;\n    align-items: center;\n    flex-direction: column;\n    width: 97%;\n    height: 100dvh;\n    padding: 10px;\n    position: relative;\n    .diamondPreview {\n      width: 100%;\n      height: 50%;\n      @media only screen and (max-height: 745px) {\n        height: 43%;\n      }\n      position: relative;\n      display: flex;\n      flex-direction: column;\n      align-items: center;\n      justify-content: center;\n    }\n    .diamond {\n      background-repeat: no-repeat;\n      background-position: center;\n      width: 200px;\n      height: 200px;\n      z-index: 2;\n      position: relative;\n      display: flex;\n      align-self: center;\n      align-content: center;\n      justify-content: center;\n      background-size: 100% 100%;\n      margin-top: 60px;\n    }\n    .diamondShine {\n      position: absolute;\n      animation: clock-direction 4s infinite linear;\n      background-image: url('../../../../assets/img/shineShadow.png');\n      background-size: cover;\n      display: flex;\n      opacity: 0.5;\n      margin-top: 60px;\n      width: 270px;\n      height: 270px;\n      z-index: 1;\n    }\n    .diamondShadow {\n      position: absolute;\n      animation: reverse-rotate 4s infinite linear;\n      background-image: url('../../../../assets/img/shineShadow.png');\n      opacity: 0.5;\n      display: flex;\n      width: 270px;\n      height: 270px;\n      margin-top: 60px;\n\n      background-size: cover;\n      z-index: 1;\n    }\n    .diamondStats {\n      display: flex;\n      flex-direction: column;\n      align-items: center;\n      justify-content: center;\n      .diamondHeading {\n        display: flex;\n        flex-direction: column;\n        align-items: center;\n        justify-content: center;\n        position: relative;\n        .diamondNumber {\n          display: flex;\n          justify-content: center;\n          position: absolute;\n          top: -20px;\n          min-width: 64px;\n          width: 130px;\n          height: 42px;\n          border-radius: 20px;\n          background: linear-gradient(to right, $color-Gradient-3-1, $color-Gradient-2-2);\n          z-index: 3;\n          .locked {\n            border-left: 1px solid white;\n            color: $color-White;\n            padding-left: 3px;\n          }\n          .count,\n          .lockedNum {\n            color: $color-White;\n            font-family: $Roboto;\n            text-align: center;\n            font-size: 24px;\n            margin: 0px;\n            margin-top: 7px;\n            font-weight: 400;\n            padding-right: 20px;\n          }\n          .lockedNum {\n            margin-top: 0px;\n            padding: 0px;\n          }\n        }\n        .title {\n          color: $color-White;\n          margin-top: 40px;\n          font-family: $Crimson-Pro;\n          font-size: 40px;\n          margin-bottom: 0px;\n        }\n        .description {\n          color: $color-Secondary;\n          text-align: center;\n          font-size: 17px;\n          margin: 0;\n          margin-top: 10px;\n        }\n      }\n      footer {\n        width: 100%;\n        display: flex;\n        flex-direction: column;\n        justify-content: center;\n        align-items: center;\n\n        .tradeBlock {\n          position: absolute;\n          display: flex;\n          justify-content: space-between;\n          width: 320px;\n          z-index: 5;\n          bottom: 130px;\n          .btnsBlock {\n            display: flex;\n            width: 163px;\n            height: 48px;\n            border-radius: 10px;\n            border-top: 1px solid $color-Secondary;\n            border-left: 1px solid $color-Secondary;\n            border-bottom: 1px solid $color-Secondary;\n            .sellBtnBlock {\n              display: flex;\n              .dollarSign {\n                margin-left: 18px;\n                color: $color-White;\n                margin-top: 14px;\n              }\n              input {\n                all: unset;\n                height: 100%;\n                width: 35%;\n                color: white;\n                font-family: $Roboto;\n              }\n              .sell {\n                all: unset;\n                text-align: center;\n                display: inline-block;\n                height: 105%;\n                background: linear-gradient(to right, $color-Gradient-3-1, $color-Gradient-2-2);\n                width: 48%;\n                color: white;\n                border: 0px solid gray;\n                margin-top: -1px;\n                border-top-right-radius: 10px;\n                border-bottom-right-radius: 10px;\n              }\n            }\n          }\n          .buy {\n            all: unset;\n            text-align: center;\n            display: inline-block;\n            background: linear-gradient(to right, $color-Gradient-3-1, $color-Gradient-2-2);\n            width: 80px;\n            height: 48px;\n            color: white;\n            border: 0px solid gray;\n            margin-top: -1px;\n            border-radius: 10px;\n          }\n        }\n        .activateButton,\n        .exchangeButton {\n          display: flex;\n          align-items: center;\n          justify-content: center;\n          width: 320px;\n          background: linear-gradient(to right, $color-Gradient-3-1, $color-Gradient-2-2);\n          font-weight: 400;\n          margin-top: 50px;\n\n          margin-right: 40px;\n          padding: 15px;\n          border-radius: 10px;\n          text-align: center;\n          color: $color-White;\n          font-family: $Roboto;\n          font-size: 16px;\n          border: 0px solid;\n          position: absolute;\n          bottom: 70px;\n          margin: 0 auto;\n        }\n        .exchangeButton {\n          bottom: 10px;\n          height: 50px;\n        }\n        .inactiveExchange {\n          filter: brightness(0) saturate(100%) invert(59%) sepia(10%) saturate(1390%)\n            hue-rotate(157deg) brightness(96%) contrast(87%);\n        }\n      }\n    }\n  }\n}\n\ninput::-webkit-outer-spin-button,\ninput::-webkit-inner-spin-button {\n  -webkit-appearance: none;\n  margin: 0;\n}\n\n/* Firefox */\ninput[type='number'] {\n  -moz-appearance: textfield;\n}\n.inactiveBtn {\n  background: rgba($color: #000000, $alpha: 0) !important;\n  color: $color-Secondary !important;\n  border: 1px solid $color-Secondary !important;\n  // opacity: 0.5 ;\n}\n.inactiveSell {\n  background: rgba($color: #000000, $alpha: 0) !important;\n  border: 1px solid $color-Secondary !important;\n  height: 100% !important;\n  color: $color-Secondary !important;\n}\n.inactiveSellInput,\n.inactiveDollar {\n  color: $color-Secondary !important;\n}\n\n.diamondImage {\n  width: 100px;\n  height: 100px;\n  z-index: 10;\n  position: fixed;\n  right: 0;\n  left: 0;\n  top: 0;\n  bottom: 0;\n  margin: auto;\n  animation: appear 1s linear;\n}\n.diamondText {\n  width: 360px;\n  height: 100px;\n  z-index: 10;\n  position: fixed;\n  right: 0;\n  left: 0;\n  top: 0;\n  bottom: 0;\n  margin: auto;\n  animation: appear 1s linear;\n  text-align: center;\n  color: $color-White;\n  font-family: $Roboto;\n  font-size: 20px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 140%;\n  animation: appear 0.15s linear;\n\n  // margin: 10px 0px 5px 0px;\n}\n.diamondClose {\n  width: 320px;\n  height: 20px;\n  padding: 24px;\n  background: linear-gradient(to right, $color-Gradient-3-1, $color-Gradient-2-2);\n  text-align: center;\n  color: $color-White;\n  font-family: $Roboto;\n  font-weight: 400;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 10px;\n  font-size: 16px;\n  font-style: normal;\n  border: 0px solid;\n  z-index: 10;\n  position: fixed;\n  right: 0;\n  left: 0;\n  top: 0;\n  bottom: -80dvh;\n  margin: auto;\n  animation: appear 0.15s linear;\n}\n.minimize {\n  animation: minimize 1s linear;\n  -webkit-animation-fill-mode: forwards;\n}\n\n.active {\n  border: 2px solid rgb(149, 179, 202);\n  h1 {\n    color: $color-White !important;\n  }\n  p {\n    color: $color-White;\n    opacity: 1 !important;\n  }\n}\n@keyframes clock-direction {\n  0% {\n    transform: rotate(0deg);\n  }\n  100% {\n    transform: rotate(360deg);\n  }\n}\n\n@keyframes reverse-rotate {\n  0% {\n    transform: rotate(0deg);\n  }\n  100% {\n    transform: rotate(-360deg);\n  }\n}\n\n@keyframes minimize {\n  0% {\n    transform: scale(1);\n    opacity: 1;\n  }\n  50% {\n    transform: scale(0.5);\n    opacity: 0.5;\n  }\n  100% {\n    transform: scale(0);\n    opacity: 0;\n\n    width: 0px;\n    height: 0px;\n    opacity: 0.8;\n  }\n}\n\n@keyframes pulse {\n  0% {\n    -webkit-transform: scale(1);\n    //   opacity: 0.2;\n  }\n  50% {\n    -webkit-transform: scale(1.3);\n    //   opacity: 1;\n  }\n  100% {\n    -webkit-transform: scale(1);\n    //   opacity: 0;\n  }\n}\n\n@keyframes appear {\n  0% {\n    opacity: 0;\n  }\n  50% {\n    opacity: 0.5;\n  }\n  100% {\n    opacity: 1;\n  }\n}\n","$color-White:#FFFFFF;\n$color-Secondary:#699BB6;\n\n$color-Gradient-1-2:#002F48;\n$color-Gradient-2-2:#FF6B6B;\n$color-Gradient-3-2:#987EE4;\n$color-Gradient-4-2:#F595DF; \n$color-Gradient-5-2:#FEA5A5;\n\n$color-Gradient-1-1:#216B93;\n$color-Gradient-2-1:#F595DF;\n$color-Gradient-3-1:#6D4ECB;\n$color-Gradient-4-1:#C465AE;\n\n","@import url('https://fonts.googleapis.com/css2?family=Alfa+Slab+One&family=Bitter:wght@400;700;900&family=Crimson+Pro:wght@700;900&family=Noto+Serif:wght@900&family=Roboto:wght@400;500;700;900&display=swap');\n$Bitter: 'Bitter', serif;   \n$Crimson-Pro: 'Crimson Pro', serif;\n$Alfa-Slab-One: 'Alfa Slab One', serif;\n$Noto-Serif: 'Noto Serif', serif;\n$Roboto: 'Roboto', sans-serif;"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
